import React from 'react'

function Header() {

  const styleHeader = {
    marginBottom : '6em'
  }


  return (
    <div style = {styleHeader}>
        <h1>
        HANGMAN
        
        </h1>
        </div>


  )
}

export default Header